import React, { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../hooks/store-hooks";
import { useLocation } from "react-router-dom";
import { setSelectedType } from "../../../store/slices/searchSlice";

const LeftSidebar = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { selectedType } = useAppSelector((state: any) => state.search || {});
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const query = params.get("q");
    if (query) {
      setSearchQuery(query);
    }
  }, [location.search]);

  return (
    <div className="lg:col-span-3 rounded-lg space-y-6 h-min">
      <div
        className={`bg-white p-4 rounded-[12px] border border-solid border-primary-600 overflow-y-auto h-auto max-h-64`}
      >
        <div className="text-[17px] text-[#090909] font-bold mb-4">
          Search results for: "{searchQuery}"
        </div>
        <hr className="w-6/7 border-t border-[#EBEBEB]" />
        <div className="flex lg:flex-col flex-row relative mt-4">
          <button
            className={`text-left md:py-3 px-2 py-1 rounded-xl-10 text-[#808080] ${
              selectedType === "post" && "bg-[#E7ECFC] font-semibold text-black"
            }`}
            onClick={() => dispatch(setSelectedType("post"))}
          >
            Posts
          </button>
          <button
            className={`text-left md:py-3 px-2 py-1 rounded-xl-10 text-[#808080] ${
              selectedType === "user" && "bg-[#E7ECFC] font-semibold text-black"
            }`}
            onClick={() => dispatch(setSelectedType("user"))}
          >
            People
          </button>
        </div>
      </div>
    </div>
  );
};

export default LeftSidebar;
